
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { buildApiUrl } from '../utils/api';

const AberturaChamado = () => {
  const [cnpj, setCnpj] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const verificarCnpj = async (e) => {
    e.preventDefault();
    setMensagem("");
    setLoading(true);

    try {
      const response = await fetch(buildApiUrl('/api/verificar-cnpj'), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ cnpj }),
      });

      const data = await response.json();

      if (response.ok && data.valido) {
        navigate("/formulario-chamado", { state: { cnpj } });
      } else {
        setMensagem("❌ CNPJ não autorizado a abrir chamados.");
      }
    } catch (error) {
      setMensagem("❌ Erro ao conectar ao servidor.");
    } finally {
      setLoading(false);
    }
  };


  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
      className="w-full max-w-lg mx-auto p-4 xs:p-5 sm:p-6 bg-white shadow-md 
                 rounded-lg xs:rounded-xl mt-8 min-w-0"
    >
      <motion.h2
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="text-lg xs:text-xl xs2:text-xl xs3:text-2xl sm:text-2xl 
                  md:text-3xl font-bold text-gray-800 mb-3 xs:mb-4 text-center"
      >
        Abertura de Chamado Contratantes
      </motion.h2>
      <p className="text-gray-600 text-xs xs:text-sm sm:text-base mb-4 text-center">
        Informe seu CNPJ para verificar autorização.
      </p>

      <form onSubmit={verificarCnpj} className="flex flex-col sm:flex-row gap-3 w-full">
        <input
          type="text"
          placeholder="Digite seu CNPJ"
          value={cnpj}
          onChange={(e) => setCnpj(e.target.value)}
          className="flex-1 min-w-0 input-modern"
          required
          aria-label="CNPJ"
        />
        <button
          type="submit"
          disabled={loading}
          className={`shrink-0 px-4 xs:px-5 sm:px-6 py-2.5 xs:py-3 rounded-lg 
                    text-white font-medium transition-all whitespace-nowrap
                    text-xs xs:text-sm sm:text-base ${
            loading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-primary-600 hover:bg-primary-700"
          }`}
        >
          {loading ? (
            <>
              <svg className="animate-spin h-4 w-4 xs:h-5 xs:w-5 inline-block mr-2" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
              </svg>
              Verificando...
            </>
          ) : (
            "Prosseguir"
          )}
        </button>
      </form>

      <AnimatePresence>
        {mensagem && (
          <motion.p
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3 }}
            className={`mt-3 text-xs xs:text-sm font-medium flex items-center gap-2 ${
              mensagem.includes("✅") ? "text-green-600" : "text-red-600"
            }`}
          >
            <span>{mensagem.includes("✅") ? "✅" : "❌"}</span>
            {mensagem.replace(/[✅❌]/g, "").trim()}
          </motion.p>
        )}
      </AnimatePresence>
    </motion.div>
  );
};



export default AberturaChamado;

